export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img10-dcb21a77981b9f4dc0f38cda5a275c0a.png";